export const nlData = {
  title: "Privacy- en Cookiebeleid – Danghuan",
  sections: [
    {
      title: "Inleiding",
      content: `
        <p>Dit Privacy- en Cookiebeleid legt uit hoe Danghuan Europe S.L. ('wij', 'ons' of 'Danghuan') uw persoonsgegevens verzamelt, gebruikt en beschermt wanneer u gebruikmaakt van onze websites en diensten. Dit beleid is van toepassing op inwoners van de Europese Economische Ruimte (EER) en het Verenigd Koninkrijk (VK) en voldoet aan de Algemene Verordening Gegevensbescherming (AVG / GDPR) en de UK GDPR.</p>
      `
    },
    {
      title: "Toepassingsgebied van dit Beleid",
      content: `
        <p>Dit beleid geldt voor:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Bezoekers van onze website (https://www.danghuan.eu)</li>
          <li style='margin-bottom: 8px;'>Klanten en potentiële klanten</li>
          <li style='margin-bottom: 8px;'>Gebruikers van onze trade-in- en doorverkoopdiensten</li>
          <li style='margin-bottom: 8px;'>Vertegenwoordigers van zakelijke partners en platformpartners</li>
        </ul>
      `
    },
    {
      title: "Welke Gegevens Wij Verzamelen",
      content: `
        <p>Afhankelijk van uw interactie met ons kunnen wij de volgende gegevens verzamelen:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Volledige naam, adres, e-mailadres en telefoonnummer</li>
          <li style='margin-bottom: 8px;'>IBAN, rekeningnummer, PayPal-, Revolut- of andere betaalgegevens</li>
          <li style='margin-bottom: 8px;'>Apparaatgegevens (model, merk, staat, prijsinformatie, IMEI)</li>
          <li style='margin-bottom: 8px;'>Communicatiegeschiedenis met onze klantenservice</li>
          <li style='margin-bottom: 8px;'>Marketingvoorkeuren en interacties met campagnes</li>
          <li style='margin-bottom: 8px;'>IP-adres, browsertype, sessie-ID en locatie</li>
          <li style='margin-bottom: 8px;'>Platformgegevens van Shopify, Amazon, TEMU of Back Market</li>
        </ul>
        <p>Wij kunnen bepaalde gegevens over u ontvangen van onze platform- of logistieke partners (zoals Shopify, Amazon, Back Market of TEMU) wanneer u via hun platformen met onze diensten communiceert — inclusief bestelgegevens, verzendadres en transactiestatus.</p>
      `
    },
    {
      title: "Gebruik van Persoonsgegevens",
      content: `
        <p>Wij gebruiken uw persoonsgegevens om:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Uw trade-in-, verkoop- of serviceverzoeken te verwerken en af te ronden</li>
          <li style='margin-bottom: 8px;'>Contact met u op te nemen over bestelstatus, verzendinformatie of ondersteuningsverzoeken</li>
          <li style='margin-bottom: 8px;'>Onze klantenservice, operationele efficiëntie en gebruikerservaring te verbeteren</li>
          <li style='margin-bottom: 8px;'>Te voldoen aan wettelijke en regelgevende verplichtingen, waaronder boekhoudkundige, fiscale en rapportagevereisten</li>
          <li style='margin-bottom: 8px;'>Het gebruik van onze diensten te analyseren en te monitoren om fraude of misbruik te voorkomen</li>
          <li style='margin-bottom: 8px;'>Met u te communiceren over campagnes, service-updates of wijzigingen in de voorwaarden, waar relevant en wettelijk toegestaan</li>
        </ul>
      `
    },
    {
      title: "Cookies",
      content: `
        <p>Wij gebruiken cookies om uw browse-ervaring te verbeteren en onze diensten te optimaliseren. Cookies kunnen de volgende informatie verzamelen:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>IP-adres en geolocatie</li>
          <li style='margin-bottom: 8px;'>Browser-/apparaatherkenning</li>
          <li style='margin-bottom: 8px;'>Gebruiksgedrag (bekeken pagina's, tijd op de site, klikken)</li>
        </ul>
        <p>Soorten cookies:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Strikt noodzakelijke cookies</li>
          <li style='margin-bottom: 8px;'>Functionele cookies</li>
          <li style='margin-bottom: 8px;'>Prestatiecookies</li>
          <li style='margin-bottom: 8px;'>Advertentiecookies</li>
        </ul>
        <p>U kunt uw cookie-instellingen op elk moment beheren of intrekken via uw browser of de cookie-banner.</p>
      `
    },
    {
      title: "Derden Met Wie Wij Gegevens Delen",
      content: `
        <p>Wij delen gegevens met betaal- en logistieke partners op basis van contractuele noodzaak; en met analyseproviders op basis van uw cookie-toestemming.</p>
        <p>Wij kunnen uw gegevens delen met:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Betaalpartners: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li style='margin-bottom: 8px;'>Logistieke providers: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li style='margin-bottom: 8px;'>Platformpartners: Shopify, Amazon, TEMU, BackMarket</li>
          <li style='margin-bottom: 8px;'>Marketing- en analysepartners: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li style='margin-bottom: 8px;'>IT-providers, consultants, juridische adviseurs</li>
          <li style='margin-bottom: 8px;'>Overheidsinstanties, indien wettelijk vereist</li>
        </ul>
        <p>Gegevens kunnen buiten de EER of het VK worden overgedragen onder door de EU goedgekeurde waarborgen, zoals de Standaardcontractbepalingen (SCC's).</p>
      `
    },
    {
      title: "Gebruik van Merken en Logo's van Derden",
      content: `
        <p>Onze website toont merknamen en logo's zoals Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google en andere, uitsluitend ter identificatie van compatibele apparaten voor trade-in- of doorverkoopdoeleinden. Alle handelsmerken zijn eigendom van hun respectieve houders. Danghuan Europe is een onafhankelijke dienstverlener en is niet gelieerd aan, erkend door of gesponsord door deze merken, tenzij uitdrukkelijk vermeld. Het tonen van deze logo's impliceert geen formele zakelijke relatie.</p>
        <p>Het gebruik van merken en logo's van derden is uitsluitend beschrijvend. Alle merken behouden hun respectieve rechten, en er wordt geen enkele band met Danghuan verondersteld.</p>
      `
    },
    {
      title: "Bewaring en Beveiliging van Gegevens",
      content: `
        <p>Wij bewaren uw gegevens alleen zolang dat nodig is voor de hierboven beschreven doeleinden of zoals wettelijk vereist. Wij hanteren passende technische en organisatorische maatregelen om uw gegevens te beschermen, waaronder encryptie, toegangsbeheer en beveiligde opslag.</p>
      `
    },
    {
      title: "Uw Rechten",
      content: `
        <p>Wij streven ernaar om binnen één maand te reageren op geldige verzoeken met betrekking tot uw gegevens. Om uw privacy te beschermen, kunnen wij u vragen uw identiteit te verifiëren.</p>
        <p>U hebt het recht om:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Uw gegevens in te zien en te corrigeren</li>
          <li style='margin-bottom: 8px;'>Verwijdering te verzoeken ('recht om vergeten te worden')</li>
          <li style='margin-bottom: 8px;'>Bezwaar te maken tegen of beperking te vragen van de verwerking</li>
          <li style='margin-bottom: 8px;'>Uw toestemming op elk moment in te trekken</li>
          <li style='margin-bottom: 8px;'>Overdraagbaarheid van uw gegevens te vragen (indien van toepassing)</li>
        </ul>
        <p>Om deze rechten uit te oefenen, kunt u contact opnemen via <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: "Beleidsupdates",
      content: `
        <p>Wij kunnen dit beleid van tijd tot tijd bijwerken om wijzigingen in wetgeving of onze gegevensverwerking weer te geven. De meest recente versie is altijd beschikbaar op onze website.</p>
      `
    },
    {
      title: "Contact",
      content: `
        <p>Heeft u vragen of wilt u uw rechten uitoefenen? Neem dan contact met ons op:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'><strong>Danghuan Europe S.L.</strong></li>
          <li style='margin-bottom: 8px;'><strong>E-mail:</strong> <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li style='margin-bottom: 8px;'><strong>Website:</strong> <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>U kunt ook een klacht indienen bij uw nationale gegevensbeschermingsautoriteit of bij de Spaanse gegevensbeschermingsautoriteit (Agencia Española de Protección de Datos – AEPD).</p>
      `
    },
    {
      title: "Bijlage – Uitgebreide Juridische en Cookie-Informatie",
      subsections: [
        {
          title: "1. Wettelijke Grondslagen voor Gegevensverwerking",
          content: `
            <p>De verwerking van uw persoonsgegevens is gebaseerd op:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Uitvoering van een overeenkomst (bijv. verwerken van trade-in-bestellingen, betalingen uitvoeren)</li>
              <li style='margin-bottom: 8px;'>Naleving van wettelijke verplichtingen (bijv. belastingrapportage, identiteitscontrole)</li>
              <li style='margin-bottom: 8px;'>Uw toestemming (bijv. marketingcommunicatie of cookies van derden)</li>
              <li style='margin-bottom: 8px;'>Gerechtvaardigd belang (bijv. fraudepreventie, interne analyse, serviceverbetering)</li>
            </ul>
          `
        },
        {
          title: "2. Maatregelen ter Voorkoming van Fraude",
          content: `
            <p>Wij kunnen uw persoonsgegevens (zoals serienummer, transactiepatroon, IP-locatie, IBAN-houder) gebruiken voor fraudedetectie met behulp van openbare databases en diensten van fraudepreventie-aanbieders. Dit gebeurt op basis van ons gerechtvaardigd belang om identiteitsdiefstal en misbruik van onze diensten te voorkomen.</p>
            <p>Wij nemen geen beslissingen die uitsluitend zijn gebaseerd op geautomatiseerde verwerking en die u aanzienlijk beïnvloeden.</p>
          `
        },
        {
          title: "3. Gegevensverwerking op Externe Marktplaatsen",
          content: `
            <p>Wanneer u apparaten koopt of verkoopt via externe platforms zoals Amazon, Shopify, TEMU of Back Market, kan Danghuan uw bestel- en betalingsinformatie ontvangen via versleutelde API's of beveiligde back-office-kanalen – uitsluitend voor het uitvoeren van de transactie en het bieden van after-sales-ondersteuning.</p>
          `
        },
        {
          title: "4. Categorieën en Details van Cookies",
          content: `
            <p>U kunt de volledige lijst van door ons gebruikte cookies bekijken – inclusief naam, aanbieder, doel, duur en type (eigen of van derden) – in de onderstaande tabel. Deze omvatten o.a. analysecookies van Google Analytics, retargeting-cookies van Meta, en betalingscookies van PayPal.</p>
            <table style='border-collapse: collapse; width: 100%;'>
              <thead>
                <tr>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Categorie</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Cookienaam</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Aanbieder</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Doel</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Duur</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Type</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strikt Noodzakelijk</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bewaart cookievoorkeuren</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 jaar</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Eerste partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strikt Noodzakelijk</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Handhaaft sessiestatus tussen pagina's</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sessie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Eerste partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Functioneel</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Onthoudt geselecteerde taalvoorkeur</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sessie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Eerste partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Functioneel</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Maakt live chat-ondersteuning mogelijk</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>6 maanden</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Derde partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prestatie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Verzamelt sitestatistieken</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 jaar</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Derde partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prestatie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Volgt gebruikersgedrag tussen sessies</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>24 uur</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Derde partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prestatie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Handhaaft gebruikerssessie tussen pagina's</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 jaar</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Derde partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Advertentie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Toont gepersonaliseerde advertenties op basis van gedrag</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 maanden</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Derde partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Advertentie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Volgt gebruikersinteracties en conversies</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>13 maanden</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Derde partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Advertentie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_uetsid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Volgt gebruikers tussen websites voor marketing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 dag</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Derde partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Advertentie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Gebruikt voor conversietracking</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 maanden</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Derde partij</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Advertentie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>__kla_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Identificeert bezoekers voor e-mailmarketingcampagnes</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 jaar</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Derde partij</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: "5. Promoties, Campagnes en Enquêtes",
          content: `
            <p>Wanneer u deelneemt aan onze promoties, enquêtes of prijsvragen, kunnen wij uw naam, contactgegevens en aanvullende gegevens verzamelen die specifiek zijn voor het evenement (zoals leeftijd en locatie). Deze gegevens worden uitsluitend gebruikt om het evenement te beheren, winnaars te contacteren en toekomstige campagnes te verbeteren.</p>
          `
        },
        {
          title: "6. Toezichthoudende Autoriteiten",
          content: `
            <p>Als u van mening bent dat uw privacyrechten zijn geschonden, kunt u een klacht indienen bij:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>In het Verenigd Koninkrijk: Information Commissioner's Office (ICO) – <a href="https://www.ico.org.uk" target="_blank">www.ico.org.uk</a></li>
              <li style='margin-bottom: 8px;'>In de Europese Unie: u kunt de relevante nationale toezichthouder voor uw land vinden op de website van de Europese Toezichthouder voor Gegevensbescherming (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ]
};